"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToTargetKeyIsDown = void 0;
var tslib_1 = require("tslib");
var operators_1 = require("rxjs/operators");
var filter_target_key_event_1 = require("./filter-target-key-event");
var mapToTargetKeyIsDown = function (key) { return function (keyEvents$) {
    return keyEvents$.pipe((0, filter_target_key_event_1.filterTargetKeyEvent)(key), (0, operators_1.map)(function (_a) {
        var _b = tslib_1.__read(_a, 1), du = _b[0];
        return du === 'down';
    }));
}; };
exports.mapToTargetKeyIsDown = mapToTargetKeyIsDown;
